import BuyData from "./BuyData";
const buydata={
     BuyData
}
export default buydata